import React from 'react'
import CallesDeBruto from '../../../Pesado/components/bruto/CallesDeBruto'
import { Button } from '@material-ui/core'

function ConfirmacionEgresoSeleccionados (props) {
  const { onSelectedCalleBruto, handleSubmit } = props

  return (
    <>
      <div style={{ padding: '8px', backgroundColor: '#c3c3c3', borderRadius: '8px', margibn: '0 10px' }}>
        <h5 style={{ fontWeight: 'bold' }}>Seleccionar calle de bruto</h5>
        <CallesDeBruto onSelected={onSelectedCalleBruto} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', margin: '5% auto' }}>
        <Button
          type='submit'
          color='primary'
          variant='contained'
          size='medium'
          onClick={handleSubmit}
        >
                    Confirmar
        </Button>
      </div>
    </>
  )
}

export default ConfirmacionEgresoSeleccionados
